import type { FC } from 'react'
import { ChirpThemeProvider } from '@chewy/chirp-theme-provider'
import { Utils } from '@pbt/pbt-ui-components'

export const ChirpThemeWrapper: FC = () => {
  // const isRhapsodyThemeEnabled = useSelector(
  //   getFeatureToggle(FeatureToggle.USE_RHAPSODY_THEME),
  // )

  // TODO: Enable this when Rhapsody theme is ready
  // const theme = isRhapsodyThemeEnabled ? 'rhapsody' : 'enterprise'

  const env = Utils.isLocalEnvironment() ? 'DEV' : 'PRD'

  return <ChirpThemeProvider pageRouter env={env} themes={['enterprise']} />
}
